import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { AssetApiPort } from './ports/asset-api.port';
import { AdessoAssetApiAdapter } from './adapters/adesso-asset-api.adapter';

/**
 * Provides AssetApiPort backed by the adesso-connector-api adapter.
 */
export function provideAssetApi(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: AssetApiPort, useClass: AdessoAssetApiAdapter }
  ]);
}
